
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
export default {
  props: {
    subcategories: {
      type: Array,
      default: () => []
    },
    itemCount: {
      type: Number,
      default: 0
    },
    categoryProp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedSubCategory: ""
    };
  },
  beforeMount() {
    this.selectedSubCategory = this.subcategories[0]?.subcategory_name;
  },
  computed: {
    ...mapState("menu", ["menuUploadList"])
  },
  methods: {
    submitChanges() {
      this.$emit("submit", this.selectedSubCategory);
    }
  }
};
